export enum ReactQueryKeys {
  AccountsBalances = 'accountsBalances',
  ApprovalPolicy = 'approvalPolicy',
  ApprovalRequests = 'approvalRequests',
  AggregateBalances = 'aggregateBalances',
  ApplicationStatus = 'applicationStatus',
  AUMBalances = 'aumBalanes',
  BankAccounts = 'bankAccounts',
  BankAccountsV2 = 'bankAccountsV2',
  BankAccountTransactions = 'bankAccountTransactions',
  Business = 'business',
  BusinessMembers = 'businessMembers',
  Businesses = 'businesses',
  CashAccount = 'cashAccount',
  CashDocument = 'cashDocument',
  CashDocumentMigrated = 'cashDocumentMigrated',
  CashSnapshot = 'cashSnapshot',
  ChartData = 'chartData',
  ConnectedAccounts = 'connectedAccounts',
  DashboardActivity = 'dashboardActivity',
  DashboardActivityGateway = 'dashboardActivityGateway',
  DashboardTransactions = 'dashboardTransactions',
  DividendsAndInterest = 'dividendsAndInterest',
  Documents = 'documents',
  Fees = 'fees',
  FixedIncomeTranscations = 'fixedIncomeTranscations',
  InitialOnboardingSweep = 'initialOnboardingSweep',
  InviteToken = 'inviteToken',
  LegalEntityTypes = 'legalEntityTypes',
  MonthlyReturns = 'monthlyReturns',
  Onboarding = 'onboarding',
  OnboardingToken = 'onboardingToken',
  Policies = 'policies',
  Portfolio = 'portfolio',
  Portfolios = 'portfolios',
  ProductInfo = 'productInfo',
  ProductPositions = 'productPositions',
  QuickbooksConnect = 'quickbooksConnect',
  QuickbooksStatus = 'quickbooksStatus',
  RestrictedCusips = 'restrictedCusips',
  ScheduleTransfers = 'scheduleTransfers',
  States = 'states',
  SubIndicator = 'subIndicator',
  TopIndicators = 'topIndicators',
  TreasureReserve = 'treasureReserve',
  TreasureReserveEarnings = 'treasureReserveEarnigns',
  TreasureReservePositions = 'treasureReservePositions',
  User = 'user',
  UserIP = 'userIp',
}
